<template>
  <div>
    <div class="question" v-if="isAndroid && config.type==='APP'" @click="showQuestionDialog" data-sensors-click>
      下载遇到问题 
      <img  src="https://static.ndmicro.com/tmd/landing/active-share/images/icon_question.png">
    </div>
    <nd-dialog
      class="question-dialog"
      v-model="questionDialog"
      :closeBtn="true"
      @click="questionDialog=false"
      :footer="false"
    >
      <div class="dialog-question">
        <div class="copy-btn" @click="copyUrlAndToast" data-sensors-click>
          <img src="https://static.ndmicro.com/tmd/landing/active-share/images/icon_copyLink.png">
          <span>复制下载链接</span>
        </div>
      </div>
    </nd-dialog>
  </div>
</template>

<script>
export default {
  props: ['config'],
  data () {
    return {
      questionDialog: false
    }
  },
 
  methods: {
    showQuestionDialog () {
      if (this.isAndroid) {
        this.questionDialog = true
        this.$sensors.track('PopupDisplay', { msg_name: '下载遇到问题弹窗' })
      }
    }
  }

}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.question {
  font-size: 24px;
  font-weight: 400;
  color: #FF4633;
  height: 33px;
  line-height: 33px;
  text-align: center;
  padding-top: 30px;
  img {
    padding-left: 5px;
    width: 24px;
  }
}
.question-dialog {
  /deep/.default-content {
    padding-top: 0;
  }
  .dialog-question {
    background-image: url(https://static.ndmicro.com/tmd/landing/active-share/images/img_question_pop.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
    width: 620px;
    height: 650px;
    padding-top: 505px;
    .copy-btn {
      width: 440px;
      height: 80px;
      background: linear-gradient(90deg, #FF7831 0%, #FFC994 100%);
      box-shadow: 0px 14px 20px 4px #E8EDFF;
      border-radius: 40px;
      font-size: 36px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 80px;
      text-align: center;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 40px;
        height: 40px;
      }
      span {
        padding-left: 10px;
      }
    }
  }
}
</style>